export const errorCategoryMap: Record<string, string> = {
    'verify-credentials': 'Credentials Verification',
    'retrieve-accounts': 'Accounts Retrieval',
    'retrieve-transactions': 'Transactions Retrieval'
};

export const onBoardingJobStatus: string[] = [
    'Setting up bank connection',
]
